// This mirrors the API pattern
export const POSITIVE_DECIMAL_REGEX =
    /^([1-9]\d{0,15}\.?\d{1,15}|\d\.\d{1,15}|[1-9]\d{0,15}\.|0\.|\d)$/
export const UK_POSTCODE_REGEX =
    /([Gg][Ii][Rr] 0[Aa]{2})|((([A-Za-z][0-9]{1,2})|(([A-Za-z][A-Ha-hJ-Yj-y][0-9]{1,2})|(([A-Za-z][0-9][A-Za-z])|([A-Za-z][A-Ha-hJ-Yj-y][0-9][A-Za-z]?))))\s?[0-9][A-Za-z]{2})/

export const POSITIVE_NUMBER_REGEX = /^\d+([.]\d+)?$/

export const POSITIVE_INTEGER_REGEX = /^\d+/

export const S3_TAG_REGEX = /^[a-zA-Z0-9_ \t]*$/

export const EMAIL_REGEX = /^[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+\.[a-zA-Z0-9-.]+$/
